<template>
    <new-modal
        ref="confirmDialogModal"
        :show-close-x="false"
        :close-on-bg-click="false"
        :show-header="false"
        :size="size"
    >
        <template #trigger>
            <slot name="trigger" />
        </template>

        <template #content>
            <slot name="content" />
        </template>
        <template #controls>
            <div class="flex w-auto justify-end gap-4">
                <div :class="cancelButtonCss" @click="cancel">
                    {{ cancelButtonLabel }}
                </div>
                <div :class="confirmButtonCss" @click="confirm">
                    {{ confirmButtonLabel }}
                </div>
            </div>
        </template>
    </new-modal>
</template>
<script>
import NewModal from "@/Components/NewModal";

export default {
    name: "ConfirmDialog",
    components: { NewModal },
    emits: ["confirm", "cancel"],
    props: {
        confirmButtonLabel: {
            type: String,
            default: "Confirm",
        },
        confirmButtonCss: {
            type: String,
            default: "btn btn-primary",
        },
        cancelButtonLabel: {
            type: String,
            default: "Cancel",
        },
        cancelButtonCss: {
            type: String,
            default: "btn btn-outline",
        },
        size: {
            type: String,
            default: "md",
        },
    },
    methods: {
        openDialog() {
            this.$refs.confirmDialogModal.openModal();
        },
        cancel() {
            this.$refs.confirmDialogModal.closeModal();
            this.$emit("cancel");
        },
        confirm() {
            this.$refs.confirmDialogModal.closeModal();
            this.$emit("confirm");
        },
    },
};
</script>
